import theme from "@src/theme";
import { Link } from "react-router-dom";
import styled from "styled-components";

export const StyledLink = styled(Link)`
    text-decoration: none;
    color: ${theme.palette.primary.main};
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
`;

export const ChildrenWrapper = styled.div`
    display: flex;
    align-items: center;
`;
